const groupPrefix = createApiRoute(ApiModule.ORDER, ApiAuthorization.EMPLOYEE, ApiDataModel.PROMOTION_ACTIONS)
const groupPrefixStore = createApiRoute(ApiModule.ORDER, ApiAuthorization.EMPLOYEE, ApiDataModel.PROMOTIONS)

export const apiPromotionActions = {
	fetchPromotionActionsTypes: async () => {
		const { data } = await apiCommon<IDiscountPromotionAction[]>(`${groupPrefix}/types`, {
			method: 'GET',
		})
		return { data: data.map(PromotionAction) }
	},
	fetchPromotionAction: async (actionID: number) => {
		const { data } = await apiCommon<IDiscountPromotionAction>(`${groupPrefix}/${actionID}`, {
			method: 'GET',
		})
		return { data: PromotionAction(data) }
	},
	createPromotionAction: async (id: number, payload: IDiscountPromotionActionCreatePayload) => {
		const { data } = await apiCommon<IDiscountPromotionAction>(`${groupPrefixStore}/${id}/promotion-actions`, {
			method: 'POST',
			body: payload,
		})
		return PromotionAction(data)
	},
	storePromotionAction: async (promotionID: number, type: any, configuration: any) => {
		const { data } = await apiCommon<IDiscountPromotionAction>(
			`${groupPrefixStore}/${promotionID}/promotion-actions`,
			{
				method: 'POST',
				body: { type, configuration },
			},
		)
		return PromotionAction(data)
	},
	updatePromotionAction: async (actionID: number, type: any, configuration: any) => {
		const { data } = await apiCommon<IDiscountPromotionAction>(`${groupPrefix}/${actionID}`, {
			method: 'PUT',
			body: { type, configuration },
		})
		return PromotionAction(data)
	},
	updatePromotionActionWithPayload: async (id: number, payload: IDiscountPromotionActionUpdatePayload) => {
		const { data } = await apiCommon<IDiscountPromotionAction>(`${groupPrefix}/${id}`, {
			method: 'PUT',
			body: payload,
		})
		return PromotionAction(data)
	},
	deletePromotionAction: async (actionID: number): Promise<void> => {
		await apiCommon<IDiscountPromotionAction>(`${groupPrefix}/${actionID}`, { method: 'DELETE' })
	},

	bulkCodesImport: async (file: File) => {
		const formData = new FormData()
		formData.append('file', file)

		return await apiCommon(
			`${groupPrefixStore}/import`,
			{
				method: 'POST',
				body: formData,
			},
			'pl',
			true,
		)
	},
}
